export const nthNumber = number => {
	const addNumberToNth = nth => `${number}${nth}`;

	if (number > 3 && number < 21) return addNumberToNth("th");

	switch (number % 10) {
		case 1:
			return addNumberToNth("st");
		case 2:
			return addNumberToNth("nd");
		case 3:
			return addNumberToNth("rd");
		default:
			return addNumberToNth("th");
	}
};
